/** Offline fallback aligned with odos_client send flow when public APIs fail. */

export const DEFAULT_VEHICLE_TYPE = "MOTORCYCLE";

export const FALLBACK_VEHICLE_TYPES = [
  { code: "MOTORCYCLE", title: "Motorcycle / two-wheel", description: "Small parcels, dense urban delivery." },
  { code: "THREE_WHEELER", title: "Three-wheeler (Bajaj / tuk-tuk)", description: "Compact cargo or short urban hops." },
  { code: "PASSENGER_CAR", title: "Passenger car", description: "Light parcels and documents." },
  { code: "CARGO_VAN", title: "Cargo van", description: "Panel or cargo van for volume shipments." },
  { code: "PICKUP", title: "Pickup truck", description: "Open bed for mixed or bulky goods." },
  { code: "LIGHT_TRUCK", title: "Light truck", description: "Small rigid truck." },
  { code: "MEDIUM_TRUCK", title: "Medium truck", description: "Box or rigid truck." },
  { code: "HEAVY_TRUCK", title: "Heavy / flatbed", description: "Large rigid or specialized haul." },
  { code: "REFRIGERATED_VAN", title: "Refrigerated van", description: "Temperature-controlled." },
];

export const FALLBACK_VEHICLE_STANDARDS = [
  { code: "COLD_CHAIN", title: "Cold chain", description: "Refrigerated or temperature-controlled." },
  { code: "WHEELCHAIR_ACCESS", title: "Wheelchair accessible", description: "Lift or ramp and securement." },
  { code: "FRAGILE_HANDLING", title: "Fragile / special handling", description: "Extra care for fragile cargo." },
  { code: "LIVESTOCK", title: "Livestock-safe", description: "Ventilation and containment." },
  { code: "HAZMAT_BASIC", title: "Basic hazmat", description: "Limited hazmat procedures." },
  { code: "MEDICAL_TRANSPORT", title: "Medical / clinical", description: "Regulated clinical and specimen loads requiring chain-of-custody." },
  { code: "HIGH_VALUE_CARGO", title: "High-value cargo", description: "Minimal handling, sealed procedures." },
  { code: "OVERSIZED_LOAD", title: "Oversized load", description: "Non-standard dimensions." },
];
